import React from 'react';
import ClassAssembly  from 'views/ClassAssembly8D';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;